module.exports = anno;


//////////////////
// WEBPACK FOOTER
// external "anno"
// module id = 2221
// module chunks = 0